<sk-wave [isRunning]="isLoading"></sk-wave>
<div class="console-inline">
    <div class="consoleHeader" consoleHeaderOffset
    [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''" *ngIf="RequestModel && !isLoading">
        <div class="row flex-nowrap">
            <div class="col-auto topFilters header_section">
                <a *ngFor="let row of PropStatModel" [ngClass]="(RequestModel.StatusCode == row.Id ? 'active' : '')" href="javascript:{}" (click)="onTopFilter(row.Id)" class="">
                    <div class="topFilter_Label text-center">{{row.Label | translate}} ({{row.Value}})</div>
                </a>
            </div>
        </div>
    </div>

    <div class="jobconsole-inline">
        <JobSearchResult_Compact #jobSearchResult [RequestModel]="RequestModel"  [Mode]="Mode"></JobSearchResult_Compact>
    </div>
</div>


